import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import './_employeeAttendance.scss'
import SubmitAttendanceModal from './submitAttendanceModal'

class EmployeeAttendanceSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            branch: "",
            branchError: "",
            defaultvalue: 0,
            getEmployeesAttendanceStatus: [],
            loadingSpinner: 0,
            currentStep: 1,

            currentDate: new Date().toISOString().slice(0, 10),
            date: new Date().toISOString().slice(0, 10),

            totalEmployees: 0,
            presentEmployees: 0,
            absentEmployees: 0,
            halfDayEmployees: 0,
            is_submit: false,
            modalShow1: false,
        }
    }
    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value, branchError: "", getEmployeesAttendanceStatus: [],is_submit:false }, () => {
        });
    };


    getEmployeesAttendanceStatus = async () => {

        if (this.state.branch == 0) {
            this.setState({ branchError: "Please select branch" });
            return "";
        }

        this.setState({ loadingSpinner: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$date:String){
                getEmployeesAttendanceStatus(institute_id:$institute_id,branch_id:$branch_id,date:$date){
                    emp_mobile
                    employee_name
                    attendance_status
                    employee_id
                    employee_type
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                date: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            }
        })

        if (result.data.getEmployeesAttendanceStatus.length > 0) {

            let employeesData = [];
            result.data.getEmployeesAttendanceStatus.map((item) => {
                let label = "Present";
                if (parseInt(item.attendance_status == 1)) {
                    label = "Present"
                } else if (parseInt(item.attendance_status == 0)) {
                    label = "Absent"
                } else if (parseInt(item.attendance_status == 3)) {
                    label = "Half Day"
                }
                employeesData.push({ ...item, value: parseInt(item.attendance_status), label })
            })

            let totalEmployees = employeesData.length;
            let no_of_emp_present = employeesData.filter((item) => item.value == 1).length;
            let no_of_emp_Absent = employeesData.filter((item) => item.value == 0).length;
            let no_of_emp_halfDay = employeesData.filter((item) => item.value == 3).length;

            this.setState({
                getEmployeesAttendanceStatus: employeesData,
                loadingSpinner: 0,
                is_submit: true,
                presentEmployees: no_of_emp_present,
                absentEmployees: no_of_emp_Absent,
                halfDayEmployees: no_of_emp_halfDay,
                totalEmployees: totalEmployees
            })
        } else {
            this.setState({
                getEmployeesAttendanceStatus: [],
                loadingSpinner: 0,
                is_submit: true,
            })
        }
    }

    selDate = (e) => {
        this.setState({ date: e.target.value, getEmployeesAttendanceStatus: [],is_submit:false })
    }

    present(cell, row, rowIndex, formatExtraData) {
        let attendance_status = [{ value: 1, label: "Present" }, { value: 0, label: "Absent" }, { value: 3, label: "Half Day" }]
        let attendedStatus = this.state.getEmployeesAttendanceStatus.filter((item) => item.emp_mobile == row.emp_mobile)
        return (
            <>
                <select class="form-control" onChange={(e) => { this.presentOrAbsent(e, row) }}>
                    {
                        attendance_status.map((item) => {
                            if (item.value == attendedStatus[0].value) {
                                return <option value={item.value} selected >{item.label}</option>
                            } else {
                                return <option value={item.value}>{item.label}</option>
                            }
                        })
                    }
                </select>
            </>
        )
    }

    presentOrAbsent(e, row) {
        console.log("rowwwwwwwwwwwwwwwww", e.target.value, row)

        let employeeAttendanceData = []

        employeeAttendanceData = this.state.getEmployeesAttendanceStatus.map((item) => {
            if (item.emp_mobile == row.emp_mobile) {
                if (e.target.value == 1) {
                    return { ...item, value: 1, label: "Present" }
                } else if (e.target.value == 0) {
                    return { ...item, value: 0, label: "Absent" }
                } else if (e.target.value == 3) {
                    return { ...item, value: 3, label: "Half Day" }
                }
            } else {
                return { ...item }
            }
        })

        let totalEmployees = this.state.getEmployeesAttendanceStatus.length;
        let no_of_emp_present = employeeAttendanceData.filter((item) => item.value == 1).length;
        let no_of_emp_Absent = employeeAttendanceData.filter((item) => item.value == 0).length;
        let no_of_emp_halfDay = employeeAttendanceData.filter((item) => item.value == 3).length;

        this.setState({
            getEmployeesAttendanceStatus: employeeAttendanceData,
            totalEmployees: totalEmployees,
            presentEmployees: no_of_emp_present,
            absentEmployees: no_of_emp_Absent,
            halfDayEmployees: no_of_emp_halfDay,
            is_submit:false
        })
    }

    articlecolumns = [
        {
            dataField: "employee_name",
            text: "Employee Name",
        },
        {
            dataField: "emp_mobile",
            text: "Mobile",
        },
        {
            dataField: "employee_type",
            text: "Designation",
        },
        {
            dataField: "attendance_status",
            text: "Attendance Status",
            formatter: this.present.bind(this)
        },
    ];

    render() {
        console.log("state", this.state);
        return (
            <Container className="employee_attendance">
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">EMPLOYEE ATTENDANCE</h2>
                            <div className="filter-block d-flex align-items-center mr-4">
                                <input type="date" className="calender" value={this.state.date} onChange={this.selDate} max={this.state.currentDate} />
                            </div>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>Select Branch</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <Button className="text-uppercase submit_btn" onClick={(e) => this.getEmployeesAttendanceStatus()}>geT employees</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>

                {
                    this.state.getEmployeesAttendanceStatus.length > 0 ?
                        (
                            <>
                                <Row className="mt-2">
                                    <Col sm={12}>
                                        <h6 className="text-danger">Note: By default all Employees are marked as present. Change to mark as Absent/Half Day</h6>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={8}>
                                        <CardLessDataTable
                                            parentData={this.state.getEmployeesAttendanceStatus}
                                            particlecolumns={this.articlecolumns}
                                            name="attendance"
                                            searchBar={true}
                                        />
                                    </Col>

                                    <Col sm={12} lg={12}>
                                        <div className="filter-block d-flex align-items-center justify-content-end mr-4">
                                            <Button className="text-uppercase  mb_50" onClick={() => this.setState({ modalShow1: true })}>Submit attendance</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className={this.state.loadingSpinner == 1 ? "d-flex align-items-center spinner-border  text-center loading-img-center" : ""}  style={{color:"#213046"}}>
                                        </div>
                                    </Col >

                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {
                                            this.state.is_submit ? (
                                                <div>
                                                    <h6 className="d-flex justify-content-center align-items-center">No Data Available</h6>
                                                </div>
                                            ) : ("")
                                        }
                                    </Col >
                                </Row>

                            </Container >
                        )
                }
                <Row>
                    <SubmitAttendanceModal
                        show={this.state.modalShow1}
                        onHide={() => this.setState({ modalShow1: false })}
                        stateData={this.state}
                    />
                </Row>
            </Container>
        )
    }
}

export default withRouter(withApollo(
    compose(

    )(EmployeeAttendanceSection))
);